import React from "react";
import { Link } from "react-router-dom";

const MessageScreen = () => {
  return (
    <div className="message p-lg-5 pt-4 pb-4">
      <div className="head pt-lg-3">
        <h3>Message From The Chairman</h3>
      </div>
      <div className="chairman pt-5">
        <div className="col-lg-6 p-md-4">
          <div className="name mb-4">
            <h3>Mr. Indra Bahadur Bista</h3>
            <p>
              <i>Chairman, Happy Energy Pvt. Ltd.</i>
            </p>
          </div>
          <div className="message pt-2">
            <p>
              <em>Greetings!!!</em>
              <br />
              <strong>
                Firstly, let me thank you for visiting Happy Energy Pvt Ltd.
              </strong>{" "}
              <br />
              There's no shortage of remarkable ideas, what's missing is the
              will to execute them. With the will of contributing towards
              sustainable development and productive economy for the foundation
              of Prosperous Nepal and Happy Nepali, a small effort has been made
              to identify, evaluate and develop technical and financially viable
              Hydro Electric Projects.
            </p>
            <div className="read-more-w pt-2">
              <Link to="/message-from-chairman">
                <button>Read More</button>
              </Link>
            </div>
          </div>
        </div>
        <div className="col-lg-4">
          <img
            src="./images/indrasir.jpg"
            className="w-100 p-2 m-lg-3"
            alt=""
          />
        </div>
      </div>
    </div>
  );
};

export default MessageScreen;
